import { useState } from "react";
import {
  makePostApiCall,
  makePutApiCall,
  makeGetApiCall,
} from "../../../shared/makeApiCall";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useToast } from "../../../contexts/ToastContext";

export function UserBusinessViewModel() {
      const { showSuccess } = useToast();
    
  const [businesses, setBusinesses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({ page: 1, rows: 15, total: 0 });
  const [search, setSearch] = useState("");
  const navigate = useNavigate();

  // Fetch businesses
  const fetchBusinesses = async (page = 1, searchTerm = "") => {
    setLoading(true);
    const payload = { page, search: searchTerm };
    const res = await makePostApiCall("/admin/userBusinesses", payload);
    if (res.success) {
      setBusinesses(res.data.data);
      setPagination({
        page: res.data.current_page,
        rows: res.data.per_page,
        total: res.data.total,
      });
    }
    setLoading(false);
  };

  const deleteBusiness = async (businessId) => {
    setLoading(true);
    const res = await makePostApiCall(`/admin/deleteUserBusiness/${businessId}`);
    if (res.success) {
      var updatedBusinesses = businesses.filter((b) => b.id !== businessId);
      setBusinesses(updatedBusinesses);
      showSuccess("Business deleted successfully.");
    }
    setLoading(false);
  }

  // Handlers
  const onSearch = (value) => {
    setSearch(value);
    fetchBusinesses(1, value);
  };

  const onPageChange = (event) => {
    const newPage = event.page + 1;
    fetchBusinesses(newPage, search);
  };

  const emptyMessage = <span>No user businesses found.</span>;

  const columns = [
    {
      header: "Business name",
      style: { width: "20%" },
      body: (rowData) => (
        <span className="font-semibold apollo-subheading text-gray-900">
          {rowData.name}
        </span>
      ),
    },
    {
      header: "City",
      style: { width: "10%" },
      body: (rowData) => (
        <span className="font-semibold apollo-subheading text-gray-900">
          {rowData.city}
        </span>
      ),
    },
    {
      header: "Address",
      style: { width: "20%" },
      body: (rowData) => (
        <span className="font-semibold apollo-subheading text-gray-900">
          {rowData.address_1}
        </span>
      ),
    },

    {
      header: "Phone number",
      style: { width: "20%" },
      body: (rowData) => (
        <span className="font-semibold apollo-subheading text-gray-900">
          {rowData.phone_number}
        </span>
      ),
    },
    {
      header: "Actions",
      style: { width: "20%" },
      body: (rowData) => (
        <div>
          <Link
            className="inline-flex items-center justify-center px-4 py-2 bg-primary-500 hover:bg-primary-600 text-white font-medium rounded-lg shadow-sm transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
            to={`/user-businesses/${rowData.id}`}
          >
            View
          </Link>

          <button
            className="ml-2 inline-flex items-center justify-center px-4 py-2 bg-red-500 hover:bg-red-600 text-white font-medium rounded-lg shadow-sm transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
            onClick={() => deleteBusiness(rowData.id)}
          >
            Delete
          </button>
        </div>
      ),
    },
  ];

  var headerButtons = [
    {
      label: "Create business",
      onClick: () => navigate("/user-businesses/create"),
      className:
        "bg-gradient-to-r from-primary-500 to-primary-600 hover:from-primary-600 hover:to-primary-700 text-white focus:ring-primary-500",
    },
  ];

  return {
    columns,
    businesses,
    loading,
    pagination,
    onSearch,
    onPageChange,
    headerButtons,
    emptyMessage,
    fetchBusinesses,
    headerButtons,
  };
}
